module.exports = __webpack_public_path__ + "static/media/building-rectangle.58a16a84.svg";